import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import AllowCalls from './allow-call'
import Discovery from './discovery'
import { SectionHeading } from '../elements'

const Section = styled.section`
  padding: 32px 0 4px;
  > div:last-of-type {
    margin-bottom: 0;
  }
`

const EmbeddedView = () => {
  const { t } = useTranslation()
  return (
    <Section>
      <SectionHeading>
        {t('r.settings.view.privacy_settings.title', 'Privacy Settings')}
      </SectionHeading>
      <Discovery />
      <AllowCalls />
    </Section>
  )
}

export default EmbeddedView
